import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BaseDialogComponent } from '../../../../../components/kit/base-dialog/base-dialog.component';
import { fb } from '../../../../shared/shared.global-service';
import { RestoreFolderModalStore } from './restore-folder-modal.store';
import { contentGlobalSuccess } from '../../../content.error';
import {
    TextAreaInputComponent,
} from '../../../../../components/kit/input/text-area-input/text-area-input.component';

@Component({
    selector: 'app-restore-folder-modal',
    templateUrl: './restore-folder-modal.component.html',
    styleUrl: './restore-folder-modal.component.scss',
    providers: [RestoreFolderModalStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TextAreaInputComponent],
})
export class RestoreFolderModalComponent extends BaseDialogComponent implements OnInit  {
    protected store = inject(RestoreFolderModalStore);
    folderId: number | null = null;

    protected form = fb.group({
        message: fb.control<string>(''),
    });

    constructor() {
        super();
    }

    override async save() {
        if (!this.folderId) return;
        await this.store.api.restoreFolder({ id: this.folderId, message: this.form.value.message });
        contentGlobalSuccess.next('folder.restore.restored');
        this.dialogRef.close();
    }

    ngOnInit(): void {
        this.folderId = this.dialogConfig.data.folderId;
    }
}
